import {
  GetCommunityPinnedPostsQuery,
  useGetCommunityPinnedPostsQuery,
} from 'generated/graphql';
import { useAsyncQueryRaw } from '@client/new/helpers/gql';
import { Async } from '@client/new/helpers/types';
import { Post } from '../model/post.types';
import { toPost } from '../model/post.mappers';
import { CommunityId } from '../model/community.types';

const PINNED_POLL_INTERVAL_MS = 30_000;

const toPinnedPosts = (data: GetCommunityPinnedPostsQuery): Post[] =>
  data.communityPinnedPosts ? data.communityPinnedPosts.posts.map(toPost) : [];

export const useCommunityPinnedPosts = (
  communityId: CommunityId,
  canModerate: boolean,
): Async<Post[]> => {
  const query = useGetCommunityPinnedPostsQuery({
    variables: { id: communityId, canModerate },
    fetchPolicy: 'cache-and-network',
    pollInterval: PINNED_POLL_INTERVAL_MS,
  });

  const { data } = useAsyncQueryRaw({ query, mapper: toPinnedPosts });
  return data;
};
